import React, { useCallback, useEffect, useSyncExternalStore } from 'react';
import { LeaderboardsPage, PlayerFilter, ProfilePageTabId } from '@colonist/clientforge';
import { RankedModeTypes } from '../../../../shared/GameEnums.ts';
import { UILeaderboardUtils } from './UILeaderboardUtils.ts';
import { UIUtilsEjsVariables } from '../UIUtilsEjsVariables.ts';
import { UIViewProfilePopup } from '../profile/UIViewProfilePopup.ts';
import { showRankedGamesDescriptionDialog } from '../ui_popup/ranked_games_description_dialog/showRankedGamesDescriptionDialog.ts';
import { navigateToPage } from '../ui_utils/ClientUtils.ts';
import { ViewPopupLogin } from '../ui_popup/ui_popup_membership_incentive/ViewPopupLogin.ts';
import { uiManagerEvents } from '../EntryShared.ts';
import { isSubscriptionOverlayVariant } from '../store/subscription_overlay/subscriptionOverlayABTest.ts';
export const LeaderboardsPageContainer = ({ data, ctaConfig, onRankedModeChange })=>{
    var _state_myStickyRowData;
    const subscribe = useCallback((callback)=>data.subscribe(callback), [
        data
    ]);
    const getSnapshot = useCallback(()=>data.getState(), [
        data
    ]);
    const state = useSyncExternalStore(subscribe, getSnapshot);
    useEffect(()=>{
        void data.init();
        return ()=>data.dispose();
    }, [
        data
    ]);
    const handleSearchChange = (value)=>void data.changeSearch(value);
    const changeRankedModeAndNotify = async (tabId)=>{
        await data.changeRankedMode(RankedModeTypes[tabId]);
        onRankedModeChange === null || onRankedModeChange === void 0 ? void 0 : onRankedModeChange();
    };
    const handleRankedModeTabChange = (tabId)=>void changeRankedModeAndNotify(tabId);
    const handleLeaderboardChange = (leaderboardUrl)=>void data.changeLeaderboardUrl(leaderboardUrl);
    const handleLocationFlagClick = (user)=>{
        if (user.myData) return;
        if (user.countryLeaderboardUrl == undefined) return;
        void data.changeLeaderboardUrl(user.countryLeaderboardUrl);
    };
    const shouldShowLoginCta = ()=>{
        const sticky = state.myStickyRowData;
        if (sticky == undefined) return false;
        return !sticky.loggedIn;
    };
    const myRowData = data.getMyRowData();
    const unrankedOverride = (_state_myStickyRowData = state.myStickyRowData) === null || _state_myStickyRowData === void 0 ? void 0 : _state_myStickyRowData.unrankedOverrideMessage;
    const unrankedMessage = unrankedOverride != undefined ? UIUtilsEjsVariables.isUserOnMobileAppOrWeb ? {
        key: 'strings:colonistCommon.utils.n/a'
    } : unrankedOverride : undefined;
    const emptyText = state.noFriendsEmpty ? {
        key: 'strings:leaderboardPage.noRankedFriends'
    } : undefined;
    return /*#__PURE__*/ React.createElement(LeaderboardsPage, {
        rowData: state.rowData,
        myRowData: myRowData,
        unrankedMessage: unrankedMessage,
        emptyText: emptyText,
        moreDataAvailable: state.moreDataAvailable,
        leaderboards: state.tableTabs.map((tab)=>({
                id: tab.leaderboardUrl,
                label: UILeaderboardUtils.tLeaderboardTabName(tab.label)
            })),
        enabledRankedModeIds: state.enabledTabIds,
        activeRankedModeId: RankedModeTypes[state.rankedModeType],
        activeLeaderboardUrl: state.leaderboardUrl,
        searchNode: /*#__PURE__*/ React.createElement(PlayerFilter, {
            defaultValue: state.searchTerm,
            onSearch: handleSearchChange
        }),
        seasonStartDate: state.seasonStartDate,
        seasonEndDate: state.seasonEndDate,
        onRankedModeChange: handleRankedModeTabChange,
        onLeaderboardChange: handleLeaderboardChange,
        fetchMoreData: ()=>data.fetchMoreData(),
        onClickRow: (row)=>UIViewProfilePopup.init(row.username, ProfilePageTabId.Ranked),
        onClickLocationFlag: handleLocationFlagClick,
        onClickDivisionIcon: ()=>showRankedGamesDescriptionDialog(),
        onClickMembershipIcon: ()=>{
            if (isSubscriptionOverlayVariant()) uiManagerEvents.premiumMembershipCheckAction();
            else navigateToPage('/store', true, true);
        },
        onClickLogin: shouldShowLoginCta() ? ()=>new ViewPopupLogin() : undefined,
        isUserOnDiscord: UIUtilsEjsVariables.isUserOnDiscord,
        ctaConfig: ctaConfig
    });
};
